import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatDividerModule } from '@angular/material/divider'
import { MatTooltipModule } from '@angular/material/tooltip'
import { NgClass } from '@angular/common'
import { ContractItemService } from '../../../core/services/contract/contract-item/contract-item.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'

@Component({
  selector: 'logistics-contract-item-view',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatProgressBarModule, MatDividerModule, MatTooltipModule, NgClass],
  template: `
    <div class="view-dialog">
      <div class="view-header">
        <div class="view-header-left">
          <span class="view-title">Item de Logística</span>
          @if (item) {
            <div class="view-badges">
              @if (item.isEmergencial) {
                <span class="badge badge-emergency">
                  <mat-icon style="font-size:14px;width:14px;height:14px;vertical-align:middle;">bolt</mat-icon>
                  Emergencial
                </span>
              }
              @if (item.statusDescricao) {
                <span class="badge badge-status">{{ item.statusDescricao }}</span>
              }
            </div>
          }
        </div>
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      @if (loading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }

      @if (item && !loading) {
        <div class="view-body">

          <!-- Trecho -->
          <div class="view-section">
            <div class="section-title">
              <mat-icon class="section-icon">route</mat-icon>
              Trecho
            </div>
            <div class="trecho-row">
              <div class="trecho-ponto">
                <span class="trecho-label">Origem</span>
                <span class="trecho-cidade">{{ item.cidadeOrigem || '-' }}</span>
                <span class="trecho-estado">{{ item.estadoOrigem || '' }}{{ item.paisOrigem ? ' · ' + item.paisOrigem : '' }}</span>
              </div>
              <mat-icon class="trecho-arrow">arrow_forward</mat-icon>
              <div class="trecho-ponto">
                <span class="trecho-label">Destino</span>
                <span class="trecho-cidade">{{ item.cidadeDestino || '-' }}</span>
                <span class="trecho-estado">{{ item.estadoDestino || '' }}{{ item.paisDestino ? ' · ' + item.paisDestino : '' }}</span>
              </div>
            </div>
          </div>

          <mat-divider></mat-divider>

          <!-- Serviço -->
          <div class="view-section">
            <div class="section-title">
              <mat-icon class="section-icon">directions_car</mat-icon>
              Serviço
            </div>
            <div class="fields-grid">
              <div class="field-item">
                <span class="field-label">Tipo de Serviço</span>
                <span class="field-value">{{ item.tipoServicoDescricao || '-' }}</span>
              </div>
              <div class="field-item">
                <span class="field-label">Serviço</span>
                <span class="field-value">{{ item.servicoDescricao || '-' }}</span>
              </div>
              <div class="field-item">
                <span class="field-label">Tipo de Veículo</span>
                <span class="field-value">{{ item.tipoVeiculoDescricao || '-' }}</span>
              </div>
              <div class="field-item">
                <span class="field-label">Tipo de Motorista</span>
                <span class="field-value">{{ item.tipoMotoristaDescricao || '-' }}</span>
              </div>
              <div class="field-item">
                <span class="field-label">Tipo de Trecho</span>
                <span class="field-value">{{ item.tipoTrechoDescricao || '-' }}</span>
              </div>
            </div>
          </div>

          <mat-divider></mat-divider>

          <!-- Datas e horários -->
          <div class="view-section">
            <div class="section-title">
              <mat-icon class="section-icon">schedule</mat-icon>
              Datas e Horários
            </div>
            <div class="fields-grid">
              <div class="field-item">
                <span class="field-label">Data Início</span>
                <span class="field-value">{{ item.dataInicio || '-' }}</span>
              </div>
              <div class="field-item">
                <span class="field-label">Hora Início</span>
                <span class="field-value">{{ item.horaInicio ? item.horaInicio.substring(0,5) : '-' }}</span>
              </div>
              <div class="field-item">
                <span class="field-label">Data Final</span>
                <span class="field-value">{{ item.dataFinal || '-' }}</span>
              </div>
              <div class="field-item">
                <span class="field-label">Hora Final</span>
                <span class="field-value">{{ item.horaFinal ? item.horaFinal.substring(0,5) : '-' }}</span>
              </div>
              <div class="field-item">
                <span class="field-label">KM Previsto</span>
                <span class="field-value">{{ item.kmPrevisto || '-' }}</span>
              </div>
            </div>
          </div>

          <mat-divider></mat-divider>

          <!-- Valores -->
          <div class="view-section">
            <div class="section-title">
              <mat-icon class="section-icon">payments</mat-icon>
              Valores
            </div>
            <div class="fields-grid">
              <div class="field-item">
                <span class="field-label">Tarifário</span>
                <span class="field-value">{{ formatCurrency(item.valorTarifario) }}</span>
              </div>
              <div class="field-item">
                <span class="field-label">Proposta</span>
                <span class="field-value">{{ formatCurrency(item.valorProposta) }}</span>
              </div>
              <div class="field-item">
                <span class="field-label">Compra</span>
                <span class="field-value">{{ formatCurrency(item.valorCompra) }}</span>
              </div>
              <div class="field-item">
                <span class="field-label">Venda</span>
                <span class="field-value">{{ formatCurrency(item.valorVenda) }}</span>
              </div>
              <div class="field-item">
                <span class="field-label">Venda s/ Taxa</span>
                <span class="field-value">{{ formatCurrency(item.valorSemTaxa) }}</span>
              </div>
              <div class="field-item">
                <span class="field-label">Venda c/ Taxa</span>
                <span class="field-value">{{ formatCurrency(item.valorComTaxa) }}</span>
              </div>
              <div class="field-item">
                <span class="field-label">Comissão</span>
                <span class="field-value">{{ formatCurrency(item.comissao) }}</span>
              </div>
              @if (item.isEmergencial) {
                <div class="field-item">
                  <span class="field-label">Custo Emergencial</span>
                  <span class="field-value emergency-value">{{ formatCurrency(item.custoEmergencial) }}</span>
                </div>
              }
            </div>
          </div>

          <mat-divider></mat-divider>

          <!-- Passageiros e status -->
          <div class="view-section">
            <div class="section-title">
              <mat-icon class="section-icon">people</mat-icon>
              Passageiros e Status
            </div>
            <div class="fields-grid">
              <div class="field-item">
                <span class="field-label">Qtd. Passageiros</span>
                <span class="field-value">{{ item.quantidadePassageiro ?? '-' }}</span>
              </div>
              <div class="field-item">
                <span class="field-label">Tem Passageiro</span>
                <span class="field-value">{{ item.temPassageiro === 'S' ? 'Sim' : 'Não' }}</span>
              </div>
              <div class="field-item">
                <span class="field-label">Status</span>
                <span class="field-value">{{ item.statusDescricao || '-' }}</span>
              </div>
            </div>

            @if (item.passageiros?.length > 0) {
              <div class="pax-list">
                @for (p of item.passageiros; track p.passageiroId) {
                  <div class="pax-card">
                    <div class="pax-header">
                      <span class="pax-nome">{{ p.nome || '-' }}</span>
                      @if (p.speaker) {
                        <span class="pax-badge pax-badge-speaker">Speaker</span>
                      }
                    </div>
                    <div class="pax-fields">
                      @if (p.companhia) {
                        <div class="pax-field">
                          <span class="pax-label">Companhia</span>
                          <span class="pax-value">{{ p.companhia }}</span>
                        </div>
                      }
                      @if (p.voo) {
                        <div class="pax-field">
                          <span class="pax-label">Voo</span>
                          <span class="pax-value">{{ p.voo }}</span>
                        </div>
                      }
                      @if (p.hora && p.hora !== '00:00:00') {
                        <div class="pax-field">
                          <span class="pax-label">Hora</span>
                          <span class="pax-value">{{ p.hora.substring(0, 5) }}</span>
                        </div>
                      }
                      @if (p.data && p.data !== '01/01/1900') {
                        <div class="pax-field">
                          <span class="pax-label">Data</span>
                          <span class="pax-value">{{ p.data }}</span>
                        </div>
                      }
                      @if (p.contato) {
                        <div class="pax-field">
                          <span class="pax-label">Contato</span>
                          <span class="pax-value">{{ p.contato }}</span>
                        </div>
                      }
                      @if (p.documento) {
                        <div class="pax-field">
                          <span class="pax-label">Documento</span>
                          <span class="pax-value">{{ p.documento }}</span>
                        </div>
                      }
                      @if (p.cpf) {
                        <div class="pax-field">
                          <span class="pax-label">CPF</span>
                          <span class="pax-value">{{ p.cpf }}</span>
                        </div>
                      }
                      @if (p.observacoes) {
                        <div class="pax-field pax-field-full">
                          <span class="pax-label">Observações</span>
                          <span class="pax-value">{{ p.observacoes }}</span>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>

          @if (item.observacao) {
            <mat-divider></mat-divider>
            <div class="view-section">
              <div class="section-title">
                <mat-icon class="section-icon">notes</mat-icon>
                Observação
              </div>
              <p class="obs-text">{{ item.observacao }}</p>
            </div>
          }

        </div>
      }

      <div class="view-footer">
        <button mat-button (click)="close()">Fechar</button>
      </div>
    </div>
  `,
  styles: [`
    .view-dialog {
      display: flex;
      flex-direction: column;
      min-width: 600px;
      max-width: 90vw;
      max-height: 90vh;
    }
    .view-header {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 20px 24px 14px;
      border-bottom: 1px solid #e5e7eb;
      gap: 12px;
    }
    .view-header-left {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }
    .view-title {
      font-size: 16px;
      font-weight: 600;
      color: #1e293b;
    }
    .view-badges {
      display: flex;
      gap: 6px;
      flex-wrap: wrap;
    }
    .badge {
      font-size: 11px;
      font-weight: 600;
      padding: 2px 10px;
      border-radius: 12px;
      display: inline-flex;
      align-items: center;
      gap: 3px;
    }
    .badge-emergency {
      background: #fef2f2;
      color: #dc2626;
      border: 1px solid #fecaca;
    }
    .badge-status {
      background: #f0fdf4;
      color: #16a34a;
      border: 1px solid #bbf7d0;
    }
    .view-body {
      flex: 1;
      overflow-y: auto;
      padding: 4px 0;
    }
    .view-section {
      padding: 16px 24px;
    }
    .section-title {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: #64748b;
      margin-bottom: 12px;
    }
    .section-icon {
      font-size: 16px;
      width: 16px;
      height: 16px;
      color: #64748b;
    }
    .trecho-row {
      display: flex;
      align-items: center;
      gap: 16px;
    }
    .trecho-ponto {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
    .trecho-label {
      font-size: 10px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.06em;
      color: #94a3b8;
      margin-bottom: 2px;
    }
    .trecho-cidade {
      font-size: 15px;
      font-weight: 600;
      color: #1e293b;
    }
    .trecho-estado {
      font-size: 12px;
      color: #64748b;
      margin-top: 1px;
    }
    .trecho-arrow {
      color: #94a3b8;
      flex-shrink: 0;
    }
    .fields-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 12px;
    }
    .field-item {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }
    .field-label {
      font-size: 10px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: #94a3b8;
    }
    .field-value {
      font-size: 13px;
      color: #1e293b;
      font-weight: 500;
    }
    .emergency-value {
      color: #dc2626;
      font-weight: 700;
    }
    .obs-text {
      font-size: 13px;
      color: #475569;
      line-height: 1.5;
      margin: 0;
    }
    .view-footer {
      display: flex;
      justify-content: flex-end;
      padding: 12px 16px;
      border-top: 1px solid #e5e7eb;
    }
    .pax-list {
      margin-top: 14px;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
    .pax-card {
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      overflow: hidden;
    }
    .pax-header {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 12px;
      background: #f8fafc;
      border-bottom: 1px solid #e5e7eb;
    }
    .pax-nome {
      font-size: 13px;
      font-weight: 600;
      color: #1e293b;
    }
    .pax-badge {
      font-size: 10px;
      font-weight: 700;
      padding: 1px 8px;
      border-radius: 10px;
    }
    .pax-badge-speaker {
      background: #ede9fe;
      color: #6d28d9;
      border: 1px solid #ddd6fe;
    }
    .pax-fields {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      padding: 10px 12px;
    }
    .pax-field {
      display: flex;
      flex-direction: column;
      gap: 2px;
      min-width: 80px;
    }
    .pax-field-full {
      flex: 1 1 100%;
    }
    .pax-label {
      font-size: 10px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: #94a3b8;
    }
    .pax-value {
      font-size: 13px;
      color: #1e293b;
      font-weight: 500;
    }
  `],
})
export class LogisticsContractItemViewComponent implements OnInit {
  item: any = null
  loading = false

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { id: string },
    private dialogRef: MatDialogRef<LogisticsContractItemViewComponent>,
    private contractItemService: ContractItemService,
    private snackbar: SnackbarCustomService,
  ) {}

  ngOnInit() {
    this.loading = true
    this.contractItemService.getContractItembyId(this.data.id as any).subscribe({
      next: (res: any) => {
        this.item = res.data
        this.loading = false
      },
      error: () => {
        this.snackbar.error('Não foi possível carregar o item de logística.')
        this.loading = false
      },
    })
  }

  formatCurrency(value: any): string {
    if (value == null) return '-'
    const n = typeof value === 'number' ? value : parseFloat(value)
    if (isNaN(n)) return '-'
    return `R$ ${n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
  }

  close() {
    this.dialogRef.close()
  }
}
